@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span #tooltip="matTooltip" [matTooltip]="fieldConfig.tooltip"
                matTooltipPosition="below" (click)="onClickTooltip(tooltip)">
            <i class="mdi mdi-help-circle tooltip-icon"></i>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
             [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
          <span [ngStyle]="customCss">
            <span>
              {{ budgetTotal | fieldFormatType: fieldConfig.customOptions?.formatType : appManager.currentOrganization.currency }}
            </span>
            @if ((budgetTotal || budgetTotal === 0) && fieldConfig.suffixType) {
              <span>
                {{ fieldConfig.suffixType | translate }}
              </span>
            }
          </span>
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span class="overlay-icon">
              @if (preconditionsForEdition) {
                <i class="mdi mdi-pencil selectable"></i>
              } @else {
                <i [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate"
                   class="mdi mdi-pencil-off tooltip-icon"></i>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span #tooltip="matTooltip" [matTooltip]="fieldConfig.tooltip"
                (click)="onClickTooltip(tooltip)">
            <i class="mdi mdi-help-circle tooltip-icon"></i>
          </span>
        }
      </div>
      <div class="edit-budget-field-container fx-layout-col">
        @for (row of form.controls.field.controls; track i; let i = $index) {
          <div class="budget-row fx-layout-row fx-justify-start fx-align-baseline fx-gap-5" [formGroup]="row">
            @if (isPriceAmountForm(row)) {
              <mat-form-field appearance="outline" class="fx-flex-none-25-percent" floatLabel="auto">
                <mat-label>{{ 'LABEL.BUDGET_LABEL' | translate }}</mat-label>
                <input matInput type="text" formControlName="label" [required]="fieldConfig.customOptions?.required" />
                @if (row.controls.label.hasError('maxlength')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_MAX_LENGTH' | translate: {value: appConfig.FIELD_MAX_LENGTH} }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="fx-flex-20-percent" floatLabel="always">
                <mat-label>{{ 'LABEL.BUDGET_QUANTITY' | translate }}</mat-label>
                <input matInput type="number" formControlName="quantity" required />
                @if (row.controls.quantity.hasError('required')) {
                  <mat-error>{{ 'ERROR.FIELD_REQUIRED' | translate }}</mat-error>
                }
                @if (row.controls.quantity.hasError('min')) {
                  <mat-error>{{ 'ERROR.MIN_VALUE' | translate: {value: 1} }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="fx-flex-15-percent" floatLabel="always">
                <mat-label>{{ 'LABEL.BUDGET_UNIT' | translate }}</mat-label>
                <input matInput
                       type="text"
                       formControlName="unit"
                       [matAutocomplete]="autocompleteUnit"
                       (focusin)="unitChanges.next(row.value.unit)" />
                <mat-autocomplete #autocompleteUnit="matAutocomplete" panelWidth="150">
                  @for (unit of filteredUnits | async; track unit) {
                    <mat-option [value]="unit">{{ unit }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field appearance="outline" class="fx-flex-20-percent" floatLabel="always">
                <mat-label>{{ 'LABEL.BUDGET_UNITPRICE' | translate }}</mat-label>
                <input matInput type="number" formControlName="unitPrice" required />
                @if (row.controls.unitPrice.hasError('required')) {
                  <mat-error>{{ 'ERROR.FIELD_REQUIRED' | translate }}</mat-error>
                }
                @if (row.controls.unitPrice.hasError('min')) {
                  <mat-error>{{ 'ERROR.MIN_VALUE' | translate: {value: 0} }}</mat-error>
                }
              </mat-form-field>
            } @else {
              <mat-form-field appearance="outline" class="fx-flex-none-25-percent" floatLabel="auto">
                <mat-label>{{ 'LABEL.BUDGET_LABEL' | translate }}</mat-label>
                <input matInput type="text" formControlName="label" />
                @if (row.controls.label.hasError('maxlength')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_MAX_LENGTH' | translate: {value: appConfig.FIELD_MAX_LENGTH} }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="fx-flex-25-percent" floatLabel="always">
                <mat-label>{{ 'LABEL.BUDGET_RATE' | translate }}</mat-label>
                <input matInput type="number" formControlName="rate" required />
                <span matSuffix>%</span>
                @if (row.controls.rate.hasError('required')) {
                  <mat-error>{{ 'ERROR.FIELD_REQUIRED' | translate }}</mat-error>
                }
                @if (row.controls.rate.hasError('min')) {
                  <mat-error>{{ 'ERROR.MIN_VALUE' | translate: {value: 0} }}</mat-error>
                }
              </mat-form-field>
            }
            <span [id]="'total_row_' + i" class="text-right fx-flex">
              <span>
                {{ row.controls.subtotal?.value | fieldFormatType: fieldConfig.customOptions?.formatType : appManager.currentOrganization.currency }}
              </span>
              @if ((row.controls.subtotal?.value || row.controls.subtotal?.value === 0) && fieldConfig.suffixType) {
                <span>
                  {{ fieldConfig.suffixType | translate }}
                </span>
              }
            </span>
            <restricted-icon-button (onClick)="removeBudgetRow(i)"
                                    [id]="'remove-budget-row-' + i + '-button'"
                                    class="fx-flex-initial"
                                    [class]="'mdi mdi-minus-circle xs'"
                                    [matTooltip]="'BUTTON.REMOVE_ROW' | translate">
              {{ 'BUTTON.REMOVE_ROW' | translate }}
            </restricted-icon-button>
          </div>
        }
        <div class="budget-total fx-layout-row fx-justify-start fx-align-center">
          <restricted-icon-button [id]="'add-price-amount-row-button'"
                                  (onClick)="addPriceAmountRow()"
                                  class="fx-flex-initial"
                                  [class]="'mdi mdi-plus-circle sm'"
                                  [matTooltip]="'BUTTON.ADD_PRICE_AMOUNT_ROW' | translate">
            {{ 'BUTTON.ADD_PRICE_AMOUNT_ROW' | translate }}
          </restricted-icon-button>
          <restricted-icon-button [id]="'add-adjustment-rate-row-button'"
                                  (onClick)="addAdjustmentRateRow()"
                                  class="fx-flex-initial"
                                  [class]="'mdi mdi-percent-circle sm'"
                                  [matTooltip]="'BUTTON.ADD_ADJUSTMENT_RATE_ROW' | translate">
            {{ 'BUTTON.ADD_ADJUSTMENT_RATE_ROW' | translate }}
          </restricted-icon-button>
          <span class="text-right fx-flex-no-shrink-50-percent">{{ 'LABEL.TOTAL' | translate }}</span>
          <span id="budget-total-value" class="text-right fx-flex-none-25-percent">
            <span>
              {{ budgetTotal | fieldFormatType: fieldConfig.customOptions?.formatType : appManager.currentOrganization.currency }}
            </span>
            @if ((budgetTotal || budgetTotal === 0) && fieldConfig.suffixType) {
              <span>
                {{ fieldConfig.suffixType | translate }}
              </span>
            }
          </span>
        </div>
        @for (validator of erroredValidators; track validator.type) {
          <mat-error>
            {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
          </mat-error>
        }
        @if (isSingleField) {
          <div class="button-container fx-layout-row fx-justify-stretch fx-align-center">
            <span class="fx-flex"></span>
            <button id="cancel-button" (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)"
                    mat-stroked-button>
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button id="save-button"
                    (click)="onClickSave()"
                    (keyup.escape)="onEscapeCancel($event)"
                    [disabled]="!form.valid"
                    color="accent"
                    mat-raised-button>
              {{ 'BUTTON.SAVE' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
